// extracted by mini-css-extract-plugin
export default {"box":"CertificationCard_box__0SPrb"};